import { Component } from '@angular/core';

@Component({
    selector: 'app-parsing-loading-modal',
    standalone: true,
    template: `
    <div class="popup-parsing-content">
      <img src="../../../assets/loading-animation.png" alt="Loading animation" class="loading-icon"/>
      <p class="primary-text">We’re extracting key information from the CV to save you time.</p>
      <p class="secondary-text">This may take around 5 seconds.</p>
    </div>
  `,
    styles: [`
    .popup-parsing-content {
      text-align: center;
      padding: 40px;
    }
    .loading-icon {
      width: 60px;
      height: 60px;
      margin-bottom: 20px;
    }
    .primary-text {
      font-weight: bold;
      margin-bottom: 8px;
    }
    .secondary-text {
      color: #7a7a7a;
    }
  `]
})
export class ParsingLoadingModalComponent {}
